import store from '@/store'
import API from '@/services/api'

const beforeEach = (to, from, next) => {
  const hexRegex = /^[0-9a-fA-F]+$/
  if (localStorage.getItem('vuex')) {
    const vuexData = JSON.parse(localStorage.getItem('vuex')) ?? ''
    if (hexRegex.test(vuexData)) {
      const decryptedText = API.decrypt(vuexData)
      let { auth } = JSON.parse(decryptedText)
      if (auth) {
        store.state.auth.cnpj = auth.cnpj
        store.state.auth.token = auth.token
        store.state.auth.userName = auth.userName
      }
    } else {
      store.dispatch('auth/logout')
      next({ name: 'auth.login' })
    }
  }

  const requiresAuth = to.meta.requiresAuth === true
  const isAuthenticated = !!store.state.auth.token

  if (to.name === '404') {
    next()
    return
  }

  // Restrição de acesso para healthcheck - apenas CNPJ específico
  if (to.name === 'profile.healthcheck' || to.name === 'health.healthcheck') {
    const userCNPJ = store.state.auth.cnpj
    if (userCNPJ !== 12547911000112) {
      next({ name: 'home' })
      return
    }
  }

  if (requiresAuth && !isAuthenticated) {
    next({ name: 'auth.login' })
    return
  }
  if (!requiresAuth && isAuthenticated && !to.meta.allowAuthenticated) {
    next({ name: 'home' })
    return
  }
  next()
}

export default beforeEach
